import { CatastroModel } from "./catastro.model";

export class DireccionModel {
  id: number = 0;
  idCiudadano: number;
  direccionPrincipal: boolean;

  direccion: string;
  codigoPostal: string;
  poblacion: string;
  municipio: string;
  provincia: string;
  comunidadAutonoma: string;

  numero: string;
  planta: string;
  puerta: string;

  referenciaCatastral: string;
  catastro: CatastroModel;

  fechaCreacion: Date;
  fechaModificacion: Date;
  fechaBaja: Date;
}
